import React from 'react';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="space-y-6 text-center">
        <div className="flex justify-center">
          <img
            src="/assets/images/logo.svg"
            alt="GetMatch Logo"
            className="h-16 w-auto"
          />
        </div>
        <div className="space-y-2">
          <div className="flex justify-center space-x-2">
            <span
              className="animate-bounce text-2xl"
              style={{ animationDelay: '0ms' }}
            >
              ⚽
            </span>
            <span
              className="animate-bounce text-2xl"
              style={{ animationDelay: '150ms' }}
            >
              🏀
            </span>
            <span
              className="animate-bounce text-2xl"
              style={{ animationDelay: '300ms' }}
            >
              🎾
            </span>
          </div>
          <p className="text-sm text-gray-500">Preparando tu experiencia</p>
        </div>
      </div>
    </div>
  );
};
